import React from 'react';
import AppShell from '@/components/layout/AppShell';
import { adminNav } from '@/lib/navConfig';
import EmployeesManager from '@/components/employees/EmployeesManager';

export default function AdminEmployees() {
  return (
    <AppShell nav={adminNav} title="Daftar Karyawan">
      <EmployeesManager />
    </AppShell>
  );
}
